export default {
  items: [
    /*{
      title: true,
      name: 'Hot functionality',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },*/
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      title: true,
      name: 'Hot Functionality',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Message Box',
      url: '/message-box',
      icon: 'cui-inbox icons',
    },
    {
      name: 'Sender Names',
      url: '/sender-names',
      icon: 'cui-inbox icons',
    },
    {
      name: 'SMS Newsletter Lists',
      url: '/newsletter',
      icon: 'cui-rss',
    },
    {
      name: 'Birthday Messenger',
      url: '/birthday-messenger',
      icon: 'icon-calendar',
    },
    {
      name: 'SMS Collections',
      url: '/sms-collection',
      icon: 'icon-speech',
    },
    {
      name: 'Extensible SMS',
      url: '/extensible-sms',
      icon: 'icon-book-open',
      // badge: {
      //   variant: 'success',
      //   text: 'NEW'
      // }
    },
    {
      title: true,
      name: 'Making Money',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Affiliate Referral',
      url: '/affiliate-referral',
      icon: 'icon-heart icons',
    },
    {
      name: 'Agent Partnership',
      url: '/agent-partnership',
      icon: 'icon-people icons',
    },
    {
      name: 'Content Publishing',
      url: '/content-publishing',
      icon: 'icon-bubbles icons',
    },
    {
      title: true,
      name: 'Developers',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'API Documentation',
      class: 'external-link',
      url: 'https://zigatext.com/api/docs',
      icon: 'cui-code icons',
      attributes: {
        target: '_blank',
        class: 'external-link',
      },
    },
    {
      title: true,
      name: 'Extras',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Ziga Support',
      url: '#',
      icon: 'icon-support icons',
    },
  ],
};
